import React from "react";
import { useHistory } from "react-router-dom";
import useSWR from "swr";
import { TrackRecordModel } from "../../../api/models";
import { JsonApiManyResponse } from "../../../api/types";
import { addTrackRecordRoutes } from "../../../defines";
import { buildRouteUrl } from "../../../utils";
import {
  hasTrackRecordUnreviewedRecord,
  managerHasTrackRecord,
} from "../../../utils/track-record";
import { Button } from "../../common/Button";
import { ManagerProfileDivider } from "../ManagerProfileDivider";
import { ManagerProfileEmptySection } from "../ManagerProfileEmptySection";
import { useManagerProfile } from "../ManagerProfileProvider";
import { ManagerProfileSection } from "../ManagerProfileSection";
import { ManagerTrackRecord } from "../ManagerTrackRecord";
import { TrackRecordUploadDocuments } from "../ManagerTrackRecord/TrackRecordUploadDocuments";

export const TrackRecord: React.FC = () => {
  const { isEditing, manager } = useManagerProfile();
  const history = useHistory();

  const [documentUploaderOpen, setDocumentUploaderOpen] = React.useState(false);

  const { data: dataTrackRecord, isValidating: isValidatingTrackRecord } =
    useSWR<JsonApiManyResponse<TrackRecordModel>>(
      () => (manager ? `/track-records/manager/${manager.id}` : null),
      {
        // fallbackData: dTR,
      },
    );
  const { data: trackRecord } = dataTrackRecord || { data: [] };

  const hasTrackRecord =
    (isEditing && trackRecord?.length > 0) ||
    managerHasTrackRecord(trackRecord || []);

  const someTrackRecordPendingOrReviewed = (trackRecord || []).some(
    (record) => record.status === "Pending" || record.status === "Reviewed",
  );

  const hasUnreviewedRecords = hasTrackRecordUnreviewedRecord(
    trackRecord || [],
  );

  const mainActionLabel = !hasTrackRecord
    ? "Add investments"
    : hasUnreviewedRecords
    ? "Review and submit"
    : "Add investments";
  const mainActionCallback = () =>
    history.push(
      buildRouteUrl(
        hasTrackRecord && hasUnreviewedRecords
          ? addTrackRecordRoutes.REVIEW_RECORDS
          : addTrackRecordRoutes.START,
      ),
    );

  /* Hide track records if there is no records as specified in story #16043*/
  if (!isEditing && !hasTrackRecord) return <></>;

  return (
    <>
      <ManagerProfileDivider />
      <ManagerProfileSection
        w={"100%"}
        title={"Track Record"}
        action={mainActionCallback}
        actionLabel={mainActionLabel}
        titleActions={
          someTrackRecordPendingOrReviewed && (
            <>
              <Button
                mr={2}
                onClick={mainActionCallback}
                label={mainActionLabel}
                isFlat
              />
              <Button
                mr={2}
                onClick={() => setDocumentUploaderOpen(true)}
                label={"Upload documents"}
                isFlat
              />
            </>
          )
        }
      >
        <>
          {manager && (
            <>
              {!isValidatingTrackRecord && (
                <>
                  {manager && trackRecord && trackRecord?.length > 0 ? (
                    <ManagerTrackRecord
                      // dataOpportunity={dataOpportunity}
                      manager={manager}
                      trackRecord={trackRecord}
                      isEditing={isEditing}
                    />
                  ) : (
                    <>
                      {isEditing && (
                        <ManagerProfileEmptySection
                          description={
                            <>
                              Knowing your track record claims are legit speeds
                              the path to investor confidence.
                            </>
                          }
                          buttonLabel={"Add track record"}
                          onAction={() => {
                            history.push(
                              buildRouteUrl(addTrackRecordRoutes.START),
                            );
                          }}
                        />
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
        </>
        {documentUploaderOpen && (
          <TrackRecordUploadDocuments
            manager={manager}
            onClose={() => setDocumentUploaderOpen(false)}
          />
        )}
      </ManagerProfileSection>
    </>
  );
};
